import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39db6267"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination pagination-outline" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasPages.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ 'card-footer': !_ctx.removeFooter })
      }, [
        _createElementVNode("ul", _hoisted_1, [
          _createElementVNode("li", {
            class: _normalizeClass(["page-item previous m-1", { disabled: _ctx.paginaAtual == 1 }])
          }, [
            _createElementVNode("span", {
              class: "page-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(_ctx.paginaAtual - 1)))
            }, [..._hoisted_3])
          ], 2 /* CLASS */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedPages, (index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "page-item",
              key: index
            }, [
              (_ctx.validationCurrentPage(index))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    href: "#",
                    class: _normalizeClass(["page-link m-1", { active: index == _ctx.paginaAtual }]),
                    onClick: ($event: any) => (_ctx.changePage(index))
                  }, _toDisplayString(index), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("li", {
            class: _normalizeClass(["page-item next m-1", {
          disabled: _ctx.paginaAtual == _ctx.computedPages.length,
        }])
          }, [
            _createElementVNode("span", {
              class: "page-link",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(_ctx.paginaAtual + 1)))
            }, [..._hoisted_6])
          ], 2 /* CLASS */)
        ]),
        (_ctx.existeBotaoVoltar)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({ ['card-footer mt-5']: _ctx.removeFooter })
            }, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.retornar && _ctx.retornar(...args)), ["prevent"]))
              }, "Voltar")
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}